import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c74f075e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-administrative-data" }
const _hoisted_2 = { class: "flex justify-center" }
const _hoisted_3 = {
  id: "formAdministrativeData",
  class: "flex items-center flex-col rounded overflow-hidden"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "titleBold text-left" }, "Dados administrativos", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " O e-mail informado em \"Dados Pessoais\" será utilizado para realizar o acesso a nossa Plataforma e o e-mail em \"Dados Administrativos\" será utilizado para contato. ", -1))
const _hoisted_6 = { class: "input w-full" }
const _hoisted_7 = { class: "input w-full" }
const _hoisted_8 = { class: "input w-full" }
const _hoisted_9 = { class: "input w-full" }
const _hoisted_10 = { class: "input w-full" }
const _hoisted_11 = { class: "input w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Input, {
            "v-model": _ctx.fantasyName,
            onInput: _ctx.onChangeFantasyName,
            isError: _ctx.isErrorFantasyName,
            errorMessage: "Nome da empresa inválido!",
            width: "100%",
            label: "Nome da Empresa",
            required: ""
          }, null, 8, ["v-model", "onInput", "isError"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Input, {
            isError: _ctx.isErrorCompanyName,
            onInput: _ctx.onChangeCompanyName,
            errorMessage: "Razão Social inválido",
            width: "100%",
            label: "Razão Social",
            value: _ctx.companyName,
            required: ""
          }, null, 8, ["isError", "onInput", "value"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Input, {
            id: "cnpj-2323",
            "v-model": _ctx.cnpj,
            onInput: _ctx.onChangeCnpj,
            isError: _ctx.isErrorCnpj,
            errorMessage: "CNPJ inválido!",
            width: "100%",
            pattern: "^\\d{2}\\.\\d{3}\\.\\d{3}\\/\\d{4}\\-\\d{2}$",
            mask: "##.###.###/####-##",
            label: "CNPJ",
            required: ""
          }, null, 8, ["v-model", "onInput", "isError"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_Input, {
            "v-model": _ctx.corporateEmail,
            onInput: _ctx.onChangeCorporateEmail,
            isError: _ctx.isErrorCorporateEmail,
            errorMessage: "E-mail inválido!",
            pattern: "[a-z0-9]+@[a-z]+\\.[a-z]{2,3}",
            type: "email",
            width: "100%",
            label: "E-mail",
            required: ""
          }, null, 8, ["v-model", "onInput", "isError"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_Input, {
            "v-model": _ctx.corporatePhone1,
            onInput: _ctx.onChangeCorporatePhone1,
            isError: _ctx.isErrorCorporatePhone1,
            errorMessage: "Telefone inválido",
            width: "100%",
            type: "tel",
            pattern: "(\\(\\d{2}\\)\\s)(\\d{4,5}-\\d{4})",
            label: "Telefone 01",
            mask: "(##) #####-####",
            required: ""
          }, null, 8, ["v-model", "onInput", "isError"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_Input, {
            "v-model": _ctx.corporatePhone2,
            onInput: _ctx.onChangeCorporatePhone2,
            isError: _ctx.isErrorCorporatePhone2,
            pattern: "(\\(\\d{2}\\)\\s)(\\d{4,5}-\\d{4})",
            errorMessage: "Telefone inválido",
            mask: "(##) #####-####",
            width: "100%",
            label: "Telefone 02"
          }, null, 8, ["v-model", "onInput", "isError"])
        ])
      ])
    ])
  ]))
}